<template>
  <BaseOption>
    <template v-slot:body>
      <Dropbox @submitSetting="handleClickSave" />
      <BackupRestore />
      <More @submitSetting="handleClickSave" />
      <Module @submitSetting="handleClickSave" />
      <Platform @submitSetting="handleClickSave" />
    </template>
  </BaseOption>
</template>

<script>
import Event from '@/helper/event.js'
import Dropbox from './Section/Dropbox.vue'
import More from './Section/More.vue'
import BackupRestore from './Section/BackupRestore.vue'
import Module from './Section/Module.vue'
import Platform from './Section/Platform.vue'
import BaseOption from '@/views/Option/BaseOption.vue'
export default {
  mixins: [Event],
  components: {
    BaseOption,
    Dropbox,
    BackupRestore,
    Module,
    Platform,
    More
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'option/general'
    },
    submitUri() {
      return 'option/general/update'
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      this.store.commit('', data)
    },
    handleClickSave() {
      this.submitForm(this.store.getter('values', {}))
    }
  }
}
</script>
